import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "layouts/Footer";
import * as React from "react";
import TitleCustom from "components/CustomTitle";
import MDBox from "components/MDBox";
import { Grid } from "@mui/material";
import CommonSelect from "components/CommonSelect/select";
import { useState, useCallback, useEffect } from "react";
import EditCatalogs from "./editCatalogs";
import MDButton from "components/MDButton";
import AddIcon from "@mui/icons-material/Add";
import { catalogsTypeSync } from "rest/sync/requestsSync";
import { catalogsByType } from "rest/requests";
import DataTable from "examples/Tables/DataTable";
import getTableData from "./formatTableData";
import { getExcelData } from "./getExcelData";

function AensaCatalogs() {
  const catalogsTypeList = catalogsTypeSync();
  const [selectedCatalogType, setSelectedCatalogType] = useState(null);

  const [catalogs, setCatalogs] = useState([]);

  const [catalogToEdit, setCatalogToEdit] = useState(null);
  const [isEditingCatalog, setIsEditingCatalog] = useState(false);

  const getCatalogsData = useCallback(async () => {
    setCatalogs(await catalogsByType(selectedCatalogType));
  }, [selectedCatalogType]);

  useEffect(() => {
    getCatalogsData();
  }, [selectedCatalogType]);

  const refreshCatalog = useCallback(async () => {
    setCatalogs(await catalogsByType(selectedCatalogType));
  }, [isEditingCatalog]);

  useEffect(() => {
    refreshCatalog();
  }, [isEditingCatalog]);

  console.log("catalogs...", catalogs);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {isEditingCatalog ? (
        <EditCatalogs
          catalogToEdit={catalogToEdit}
          setIsEditingCatalog={setIsEditingCatalog}
          catalogsTypeList={catalogsTypeList}
        />
      ) : (
        <div>
          <TitleCustom
            title={"Administración Catalogos"}
            excelData={getExcelData(catalogs, catalogsTypeList)}
            excelName={"Administracion_Catalogos.xlsx"}
          ></TitleCustom>
          <MDBox bgColor="white" variant="gradient" borderRadius="lg" shadow="lg" opacity={1} p={2}>
            <Grid container spacing={5}>
              <Grid item>
                <CommonSelect
                  data={catalogsTypeList}
                  onChange={(selectedValue) => setSelectedCatalogType(selectedValue)}
                  label={"Seleccione el tipo de catálogo"}
                ></CommonSelect>
              </Grid>
            </Grid>
            <MDButton
              variant="text"
              size="small"
              color="secondary"
              onClick={() => {
                setCatalogToEdit(null);
                setIsEditingCatalog(true);
              }}
            >
              <AddIcon></AddIcon>
              Adicionar Catálogo
            </MDButton>
          </MDBox>
          <br></br>
          <DataTable
            table={getTableData(catalogs, setIsEditingCatalog, setCatalogToEdit)}
            canSearch={true}
          />
        </div>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default AensaCatalogs;
